module.exports = __webpack_public_path__ + "static/media/logo.3ea2d4b0.png";